export const APPLE_THEME = {
  white: '#ffffff',
  black: '#2A2A2A',
  metalicBlack: '#404040',
  metalicGray: '#717171',
  darkMetalicGray: '#555555',
  lightMetalicGray: '#F5F5F5',
  accentGray: '#888888',
  backgroundGray: '#FAFAFA',
  textGray: '#4A4A4A',
  cardBackground: '#F0F0F0'
};

export const TYPOGRAPHY = {
  hero: 'system-ui, -apple-system, BlinkMacSystemFont, "SF Pro Display", "Helvetica Neue", sans-serif',
  body: 'system-ui, -apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", sans-serif'
};

export const ANIMATIONS = {
  fast: '200ms',
  normal: '300ms',
  slow: '500ms',
  verySlow: '1000ms'
};

export const SPACING = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
  hero: '96px'
};

export const BORDER_RADIUS = {
  sm: '6px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  pill: '50px'
};

export const BREAKPOINTS = {
  mobile: '375px',
  tablet: '768px',
  desktop: '1024px',
  wide: '1440px',
  ultraWide: '1920px'
};